import { render, staticRenderFns } from "./booked-ancillaries.vue?vue&type=template&id=1fe6470e&scoped=true"
import script from "./booked-ancillaries.vue?vue&type=script&lang=js"
export * from "./booked-ancillaries.vue?vue&type=script&lang=js"
import style0 from "./booked-ancillaries.vue?vue&type=style&index=0&id=1fe6470e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6470e",
  null
  
)

export default component.exports